import { render, staticRenderFns } from "./compPropertiesCard.vue?vue&type=template&id=e66171b8&scoped=true"
import script from "./compPropertiesCard.vue?vue&type=script&lang=js"
export * from "./compPropertiesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66171b8",
  null
  
)

export default component.exports